import {Account} from '../types';

import {
    useAccountQuery,
    useCreateAccountMutation,
    useUpdateAccountMutation,
} from './useAccountsQuery';

// FNP-945: the single record comes from React Query. Return shape unchanged so
// the pages and forms consuming this hook did not change.
//
// No delete here - accounts are not deleted from the portal (the list hook's
// deleteRecords is a no-op with a warning), so no delete mutation is exposed.
export const useAccount = (accountId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useAccountQuery(accountId);

    const createMutation = useCreateAccountMutation();
    const updateMutation = useUpdateAccountMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE
    const createRecord = (values: Account) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: Account) => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }

        updateMutation.mutate({
            id: accountId,
            record: values,
        });
    };

    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
    };
};
